const css = `.business-analytics-page .p-tabview .p-tabview-nav,
.business-analytics-page .p-tabview .p-tabview-nav-link,
.business-analytics-page .p-tabview .p-tabview-panels {
  background-color: transparent;
}
.business-analytics-page .p-tabview .p-tabview-nav-content .p-tabview-nav {
  gap: 0;
}
.business-analytics-page .p-tabview .p-tabview-nav-content .p-tabview-nav li {
  width: 100%;
}
.business-analytics-page .p-tabview .p-tabview-nav-content .p-tabview-nav li .p-tabview-nav-link {
  display: flex;
  justify-content: center;
}
.business-analytics-page .p-tabview .p-tabview-panels {
  padding: 0;
}
.business-analytics-page .p-tabview .p-tabview-panel {
  flex: 1;
  flex-direction: column;
  display: flex;
  gap: 16px;
}
.business-analytics-page .filters-container {
  display: flex;
  gap: var(--gap);
  flex-wrap: wrap;
}
.business-analytics-page .filters-container .branch-filter,
.business-analytics-page .filters-container .reservation-type-filter,
.business-analytics-page .filters-container .client-type-filter {
  min-width: 212px;
}
.business-analytics-page .filters-container .date-range-selector {
  min-width: 212px;
}
.business-analytics-page .filters-container .custom-range-picker {
  min-width: 260px;
  width: auto;
}
.business-analytics-page .filters-container .month-picker {
  width: 212px;
}
.business-analytics-page .kpi-container {
  container-type: inline-size;
  container-name: kpis;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 16px;
}
.business-analytics-page .kpi-container .p-card {
  width: var(--row-quarter);
  min-height: 90px;
}
.business-analytics-page .kpi-container .p-skeleton {
  width: var(--row-quarter) !important;
  min-height: 90px !important;
}
.business-analytics-page .charts-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  container-type: inline-size;
  container-name: charts;
  gap: 16px;
}
.business-analytics-page .charts-container .p-skeleton,
.business-analytics-page .charts-container .p-card {
  width: var(--row-half) !important;
  height: 447.5px !important;
}
.business-analytics-page .charts-container .p-skeleton.full-width-chart,
.business-analytics-page .charts-container .p-card.full-width-chart {
  width: 100% !important;
}
.business-analytics-page .charts-container .p-skeleton.large-chart,
.business-analytics-page .charts-container .p-card.large-chart {
  width: var(--row-two-thirds) !important;
}
.business-analytics-page .charts-container .p-skeleton.small-chart,
.business-analytics-page .charts-container .p-card.small-chart {
  width: var(--row-third-small) !important;
}
.business-analytics-page .charts-container .p-skeleton.employee-hours-card,
.business-analytics-page .charts-container .p-card.employee-hours-card {
  height: auto !important;
}
.business-analytics-page .charts-container .p-skeleton.employee-hours-card .card-empty-state,
.business-analytics-page .charts-container .p-card.employee-hours-card .card-empty-state {
  min-height: 300px;
}

@container charts (max-width: 1200px) {
  .charts-container div.p-card.p-component.large-chart, .charts-container div.p-card.p-component.small-chart,
  .charts-container div.p-skeleton.p-component.large-chart,
  .charts-container div.p-skeleton.p-component.small-chart {
    width: var(--row-half) !important;
  }
}
@container charts (max-width: 900px) {
  .charts-container div.p-card.p-component,
  .charts-container div.p-skeleton.p-component {
    width: 100% !important;
  }
  .charts-container div.p-card.p-component.large-chart, .charts-container div.p-card.p-component.small-chart,
  .charts-container div.p-skeleton.p-component.large-chart,
  .charts-container div.p-skeleton.p-component.small-chart {
    width: 100% !important;
  }
}
@container kpis (max-width: 1024px) {
  .business-analytics-page .kpi-container .p-card {
    width: var(--row-half);
  }
  .business-analytics-page .kpi-container .p-skeleton {
    width: var(--row-half) !important;
  }
}
@container kpis (max-width: 520px) {
  .business-analytics-page .kpi-container .p-card {
    width: 100%;
  }
  .business-analytics-page .kpi-container .p-skeleton {
    width: 100% !important;
  }
}
@media (max-width: 480px) {
  .business-analytics-page .filters-container {
    flex-direction: column;
    align-items: center;
  }
  .business-analytics-page .filters-container .date-range-selector,
  .business-analytics-page .filters-container .custom-range-picker,
  .business-analytics-page .filters-container .branch-filter,
  .business-analytics-page .filters-container .reservation-type-filter,
  .business-analytics-page .filters-container .client-type-filter {
    width: 100%;
  }
}
.employee-hours-card {
  width: 100% !important;
}

.employee-hours-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.employee-hours-list .employee-hours-item {
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background-color: var(--surface-raised);
}
.employee-hours-list .employee-hours-item .employee-hours-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
}
.employee-hours-list .employee-hours-item .employee-hours-header .employee-hours-total {
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-base);
  color: var(--text-muted);
}
.employee-hours-list .employee-hours-item .employee-hours-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.employee-hours-list .employee-hours-item .employee-hours-details .employee-hours-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}
.employee-hours-list .employee-hours-item .employee-hours-details .employee-hours-detail-item .reservation-type-name {
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}
.employee-hours-list .employee-hours-item .employee-hours-details .employee-hours-detail-item .reservation-type-hours {
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
